const Link = {
    dev: {
        'mt': 'http://about.maitian.cn/',
        'mtzx': 'http://bj.maitian.cn/VIEW/Index/Index2.html',
        'fzmt': 'http://fz.maitian.cn/VIEW/Index/Index2.html',
        'xmmt': 'http://xm.maitian.cn/VIEW/Index/Index2.html',
        'gp': 'http://172.16.14.12:8080/portal-web/login.jsp',
        'zcdy': 'http://172.16.14.80:8000/print.aspx',
        'qyyx': 'https://mail.maitian.cn/',
        'sy': 'http://172.16.14.80:8000/Index.aspx',
        'ljmt':'http://172.16.14.80:8000/Know.aspx',
        'fyrw': 'http://172.16.14.80:8000/Person.aspx',
        'cpyc': 'http://172.16.14.80:8000/jionUs/Social.aspx',
        'jyts': 'http://172.16.14.80:8000/Suggest.aspx',
        'mtff': 'http://172.16.14.80:8000/Service.aspx',
        'mjj': 'http://172.16.14.80:8000/MaiJiJinIndex.aspx',
        'zc': 'http://172.16.14.120:9001/register'
    },
    qa: {
        'mt': 'http://about.maitian.cn/',
        'mtzx': 'http://bj.maitian.cn/VIEW/Index/Index2.html',
        'fzmt': 'http://fz.maitian.cn/VIEW/Index/Index2.html',
        'xmmt': 'http://xm.maitian.cn/VIEW/Index/Index2.html',
        'gp': 'http://172.16.14.12:8080/portal-web/login.jsp',
        'zcdy': 'http://172.16.14.120:8000/print.aspx',
        'qyyx': 'https://mail.maitian.cn/',
        'sy': 'http://172.16.14.120:8000/Index.aspx',
        'ljmt':'http://172.16.14.120:8000/Know.aspx',
        'fyrw': 'http://172.16.14.120:8000/Person.aspx',
        'cpyc': 'http://172.16.14.120:8000/jionUs/Social.aspx',
        'jyts': 'http://172.16.14.120:8000/Suggest.aspx',
        'mtff': 'http://172.16.14.120:8000/Service.aspx',
        'mjj': 'http://172.16.14.120:8000/MaiJiJinIndex.aspx', 
        'zc': 'http://172.16.14.120:9001/register'
    },
    production: {
        'mt': 'http://about.maitian.cn/',
        'mtzx': 'http://bj.maitian.cn/VIEW/Index/Index2.html',
        'fzmt': 'http://fz.maitian.cn/VIEW/Index/Index2.html',
        'xmmt': 'http://xm.maitian.cn/VIEW/Index/Index2.html',
        'gp': 'http://172.16.8.75/portal-web/login.jsp',
        'zcdy': 'http://14.maitian.cn/print.aspx',
        'qyyx': 'https://mail.maitian.cn/',
        'sy': 'http://14.maitian.cn/Index.aspx',
        'ljmt':'http://14.maitian.cn/Know.aspx',
        'fyrw': 'http://14.maitian.cn/Person.aspx',
        'cpyc': 'http://14.maitian.cn/jionUs/Social.aspx',
        'jyts': 'http://14.maitian.cn/Suggest.aspx',
        'mtff': 'http://14.maitian.cn/Service.aspx',
        'mjj': 'http://14.maitian.cn/MaiJiJinIndex.aspx',
        'zc': ''
    }
}
console.log(process.env.VUE_APP_ENV)
export default Link[process.env.VUE_APP_ENV]